import React from "react";
import {showlog} from "../../../utils";

export function ArticleComponent({article}: any) { // TODO Type dovrebbe essere fullItemDataDTO da MobileAgent
	// console.log('ArticleComponent', article);
	if (!article) return null
	return (
		<div className={"article-expanded-area"}>
			<div className={"article-info-container"}>

				{/*
						TODO
						immagine
					*/}

				<div>
					<h5 className={"article-name"}><strong>{article.codice}</strong> {article.articolo}</h5>
					<div className={"article-prices"}>
						{
							(article.prezzo == article.startPrice)
								? null
								: <div className={"article-start-price"}>{article.startPrice} €</div>
						}
						<div className={"article-price"}>{article.prezzo} €</div>
						<div className={"article-qt"}>{article.qt} {article.measureUnit}</div>
					</div>

				</div>
				<div className={"article-details-container"}>
					{
						Object.keys(article.details)
							.map(field => (
								<div><label>{field}</label><span>{article[field] || "0"}</span></div>
							))
					}
				</div>
				<div className={"article-details-container"}>
					<div><label>disponibilita</label><span>{article.disponibilita || "0"}</span></div>
					<div>
						<label>listino</label>
						<span>
								{
									(!!article.listino && !!article.listino.desListino)
										? (article.listino.desListino + ' [' + article.listino.idListino + ']')
										: ''
								}
							</span>
					</div>
					<div><label>listino cliente</label><span>{article.listinoCliente}</span></div>
					<div><label>listino prioritario</label><span>{article.listinoPrioritario}</span></div>
					<div><label>listino ordinario</label><span>{article.listinoOrdinario}</span></div>
					{/*<div><label>unità di misura</label><span>{article.measureUnit}</span></div>*/}
					<div><label>con IVA</label><span>{article.vatIncluded}</span></div>
					{/*
							TODO
							marca, famiglia, ecc...
						*/}
				</div>
				{/*
						TODO
						Promozioni
					*/}
			</div>
			<div className={"article-des-estesa"}>{article.DesEstesa}</div>

		</div>
	)
}
